export default "__VITE_ASSET__$D_XFh3x__"